import { css } from "@compiled/react";
import { FormattedMessage } from "react-intl";

import { media } from "@atlaskit/primitives";

import { Picture } from "@/components/wpl/image/src/image";
import { wacToken } from "@/libraries/design/foundations/index.ts";

export const EligibilityList = () => {
    return (
        <ul css={rowWrapperCss}>
            <NonGovernmental />

            <li>
                <Picture
                    image={{
                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/1665m6o0xxrphegnh7lnwf17585pj211.svg",
                        alt: ""
                    }}
                />
                <h4 css={cardTitleCss}>
                    <FormattedMessage
                        id="NonprofitPage.card.title2"
                        defaultMessage="Non-commercial"
                    />
                </h4>
                <p css={cardContentCss}>
                    <FormattedMessage
                        id="NonprofitPage.card.content2"
                        defaultMessage="operating on a not-for-profit basis and for the public benefit"
                    />
                </p>
            </li>

            <NonPolitical />

            <Nonprofit />
        </ul>
    );
};

export const EligibilityListGwp7869 = () => {
    return (
        <ul css={rowWrapperCss}>
            <NonGovernmental />
            <NonPolitical />
            <Nonprofit />

            <li>
                <Picture
                    image={{
                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/1665m6o0xxrphegnh7lnwf17585pj211.svg",
                        alt: ""
                    }}
                />
                <h4 css={cardTitleCss}>
                    <FormattedMessage
                        id="NonprofitPage.card.socialMissionTitle"
                        defaultMessage="For-profit with a social mission"
                    />
                </h4>
                <p css={cardContentCss}>
                    <FormattedMessage
                        id="NonprofitPage.card.socialMissionContent"
                        defaultMessage="<a>as defined by Atlassian</a> and verified by Goodstack"
                        values={{
                            a: (chunks) => (
                                <a css={cardContentLinkCss} href="#faq">
                                    {chunks}
                                </a>
                            )
                        }}
                    />
                </p>
            </li>
        </ul>
    );
};

const NonGovernmental = () => {
    return (
        <li>
            <Picture
                image={{
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/4vunf5vd4cboe8glor3vep3mam3a3d0o.svg",
                    alt: ""
                }}
            />
            <h4 css={cardTitleCss}>
                <FormattedMessage
                    id="NonprofitPage.card.title1"
                    defaultMessage="Non-governmental"
                />
            </h4>
            <p css={cardContentCss}>
                <FormattedMessage
                    id="NonprofitPage.card.content1"
                    defaultMessage="independent from government control"
                />
            </p>
        </li>
    );
};

const NonPolitical = () => {
    return (
        <li>
            <Picture
                image={{
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/k1y270i4t5e33yp8hw62tn3l37850050.svg",
                    alt: ""
                }}
            />
            <h4 css={cardTitleCss}>
                <FormattedMessage
                    id="NonprofitPage.card.title3"
                    defaultMessage="Non-political"
                />
            </h4>
            <p css={cardContentCss}>
                <FormattedMessage
                    id="NonprofitPage.card.content3"
                    defaultMessage="or against any political party, candidate, or campaign"
                />
            </p>
        </li>
    );
};

const Nonprofit = () => {
    return (
        <li>
            <Picture
                image={{
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/8q882ia8oh77fl481x8f01up4y2a2q18.svg",
                    alt: ""
                }}
            />
            <h4 css={cardTitleCss}>
                <FormattedMessage
                    id="NonprofitPage.card.title4"
                    defaultMessage="Recognized as a nonprofit"
                />
            </h4>
            <p css={cardContentCss}>
                <FormattedMessage
                    id="NonprofitPage.card.content4"
                    defaultMessage="in the country in which you are registered, in accordance with the "
                />
                <a
                    css={cardContentLinkCss}
                    target="_blank"
                    href="https://goodstack.org/nonprofit-definitions"
                    rel="noreferrer"
                >
                    <FormattedMessage
                        id="NonprofitPage.card.content4.link"
                        defaultMessage="eligibility criteria for that country"
                    />
                </a>
            </p>
        </li>
    );
};

const rowWrapperCss = css({
    "display": "flex",
    "flexWrap": "wrap",
    "justifyContent": "space-between",
    "listStyleType": "none",
    "padding": "0",
    "margin": 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    "& > li": {
        width: "50%",
        boxSizing: "border-box",
        padding: "16px",
        [media.above.sm]: {
            width: "25%"
        }
    }
});

const cardTitleCss = css({
    fontSize: "20px",
    lineHeight: "28px",
    margin: "0 0 12px",
    [media.above.sm]: {
        fontSize: "24px",
        lineHeight: "30px"
    }
});

const cardContentCss = css({
    margin: "0",
    maxWidth: "266px"
});

const cardContentLinkCss = css({
    color: wacToken("color.primary.blue"),
    textDecoration: "underline"
});
